// extracted by mini-css-extract-plugin
module.exports = {"Signup":"style_Signup__20SPa","logo":"style_logo__1UOAu","welcome":"style_welcome__3jThx","form":"style_form__1ttNP","footer":"style_footer__2lPys"};